import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../../redux/auth/billing/actions';

const RequestBillingInfoData = () => {
  const dispatch = useDispatch();
  const getBillingInfo = useCallback(() => dispatch(actions.getBillingInfo()), [dispatch]);

  useEffect(() => {
    getBillingInfo();
  }, [getBillingInfo]);

  return null;
};

export default RequestBillingInfoData;
